import { render } from "./RemoveToStarred.vue?vue&type=template&id=55845b64"
import script from "./RemoveToStarred.vue?vue&type=script&lang=js"
export * from "./RemoveToStarred.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__